export const CandidateListViews = Object.freeze({ All: 0, Preferred: 1 })
